import {
  CLEAR_ACTIVE_ALARMS_COUNT,
  CLEAR_ALARMS_REDUCER,
  CLEAR_ALARM_MESSAGES,
  CLEAR_CALLS_HISTORY,
  GET_ACTIVE_ALARMS_COUNT,
  GET_ACTIVE_ALARMS_COUNT_SUCCESS,
  GET_ALARMS_HISTORY_LIST,
  GET_ALARMS_HISTORY_LIST_ERROR,
  GET_ALARMS_HISTORY_LIST_SUCCESS,
  GET_ALARMS_HISTORY_MESSAGES,
  GET_ALARMS_HISTORY_MESSAGES_ERROR,
  GET_ALARMS_HISTORY_MESSAGES_SUCCESS,
  GET_ALARM_LIST,
  GET_ALARM_LIST_ERROR,
  GET_ALARM_LIST_SUCCESS,
  GET_ALARM_MESSAGE_LIST,
  GET_ALARM_MESSAGE_LIST_ERROR,
  GET_ALARM_MESSAGE_LIST_SUCCESS,
  SEARCH_CALLS_HISTORY,
  SEARCH_CALLS_HISTORY_FAILURE,
  SEARCH_CALLS_HISTORY_SUCCESS,
  SEND_ALARM_MESSAGE,
  SEND_ALARM_MESSAGE_SUCCESS,
  SEND_ALARM_MESSAGE_FAILURE,
  START_ALARM_CALL,
  START_ALARM_CALL_ERROR,
  START_ALARM_CALL_SUCCESS,
  STOP_ALARM_CALL,
  STOP_ALARM_CALL_ERROR,
  STOP_ALARM_CALL_SUCCESS,
  SET_ALARMS_HISTORY_FILTERS,
  SET_CALLS_HISTORY_FILTERS,
  CLEAR_ALARMS_HISTORY_REDUCER,
  CLEAR_ALARMS_HISTORY_FILTERS,
  CLEAR_CALLS_HISTORY_FILTERS,
} from '../constants/ActionTypes';

export const clearActiveAlarmsCount = () => ({
  type: CLEAR_ACTIVE_ALARMS_COUNT,
});

export const clearAlarmsReducer = () => ({
  type: CLEAR_ALARMS_REDUCER,
});

export const clearAlarmsHistoryFilters = () => ({
  type: CLEAR_ALARMS_HISTORY_FILTERS,
});

export const clearCallsHistoryFilters = () => ({
  type: CLEAR_CALLS_HISTORY_FILTERS,
});

export const clearAlarmsHistoryReducer = () => ({
  type: CLEAR_ALARMS_HISTORY_REDUCER,
});

export const clearAlarmMessages = () => ({
  type: CLEAR_ALARM_MESSAGES,
});

export const clearCallsHistory = () => ({
  type: CLEAR_CALLS_HISTORY,
});

export const getActiveAlarmsCount = () => ({
  type: GET_ACTIVE_ALARMS_COUNT,
});

export const getActiveAlarmsCountSuccess = activeAlarmsCount => ({
  type: GET_ACTIVE_ALARMS_COUNT_SUCCESS,
  payload: { activeAlarmsCount },
});

export const getAlarmsHistoryList = query => ({
  type: GET_ALARMS_HISTORY_LIST,
  payload: { query },
});

export const getAlarmsHistoryListError = () => ({
  type: GET_ALARMS_HISTORY_LIST_ERROR,
});

export const getAlarmsHistoryListSuccess = (alarmsHistory, pageCount) => ({
  type: GET_ALARMS_HISTORY_LIST_SUCCESS,
  payload: { alarmsHistory, pageCount },
});

export const getAlarmsHistoryMessages = alarmHistoryId => ({
  type: GET_ALARMS_HISTORY_MESSAGES,
  payload: { alarmHistoryId },
});

export const getAlarmsHistoryMessagesError = () => ({
  type: GET_ALARMS_HISTORY_MESSAGES_ERROR,
});

export const getAlarmsHistoryMessagesSuccess = (messages = []) => ({
  type: GET_ALARMS_HISTORY_MESSAGES_SUCCESS,
  payload: { messages },
});

export const getAlarmList = query => ({
  type: GET_ALARM_LIST,
  payload: { query },
});

export const getAlarmListError = () => ({
  type: GET_ALARM_LIST_ERROR,
});

export const getAlarmListSuccess = (alarms, pageCount) => ({
  type: GET_ALARM_LIST_SUCCESS,
  payload: { alarms, pageCount },
});

export const getAlarmMessageList = alarmId => ({
  type: GET_ALARM_MESSAGE_LIST,
  payload: { alarmId },
});

export const getAlarmMessageListError = () => ({
  type: GET_ALARM_MESSAGE_LIST_ERROR,
});

export const getAlarmMessageListSuccess = (messages = []) => ({
  type: GET_ALARM_MESSAGE_LIST_SUCCESS,
  payload: { messages },
});

export const searchCallsHistory = query => ({
  type: SEARCH_CALLS_HISTORY,
  payload: { query },
});

export const searchCallsHistoryFailure = () => ({
  type: SEARCH_CALLS_HISTORY_FAILURE,
});

export const setCallsHistoryFilters = filters => ({
  type: SET_CALLS_HISTORY_FILTERS,
  payload: filters,
});

export const searchCallsHistorySuccess = (calls, pageCount) => ({
  type: SEARCH_CALLS_HISTORY_SUCCESS,
  payload: { calls, pageCount },
});

export const setAlarmsHistoryFilters = filters => ({
  type: SET_ALARMS_HISTORY_FILTERS,
  payload: filters,
});

export const sendAlarmMessage = (alarmId, message, stopAlarm, query = {}) => ({
  type: SEND_ALARM_MESSAGE,
  payload: { alarmId, message, stopAlarm, query },
});

export const sendAlarmMessageSuccess = () => ({
  type: SEND_ALARM_MESSAGE_SUCCESS,
});

export const sendAlarmMessageFailure = () => ({
  type: SEND_ALARM_MESSAGE_FAILURE,
});

export const startAlarmCall = alarmId => ({
  type: START_ALARM_CALL,
  payload: { alarmId },
});

export const startAlarmCallError = ({ alarmId, error }) => ({
  type: START_ALARM_CALL_ERROR,
  payload: { alarmId, error },
});

export const startAlarmCallSuccess = ({ alarmId, responseStatus, directPhoneNumber }) => ({
  type: START_ALARM_CALL_SUCCESS,
  payload: { alarmId, responseStatus, directPhoneNumber },
});

export const stopAlarmCall = alarmId => ({
  type: STOP_ALARM_CALL,
  payload: { alarmId },
});

export const stopAlarmCallError = ({ alarmId, error }) => ({
  type: STOP_ALARM_CALL_ERROR,
  payload: { alarmId, error },
});

export const stopAlarmCallSuccess = ({ alarmId, responseStatus }) => ({
  type: STOP_ALARM_CALL_SUCCESS,
  payload: { alarmId, responseStatus },
});
